import React from "react";
import cronstrue from "cronstrue";
import { CronExpressionParser } from "cron-parser";
import { Creatable } from "react-select";
import { customMapper, selectOnChangeWrapperIfPresent } from "@/utils/select";
const CRON_MAPPER = customMapper((x) => cronstrue.toString(x, { verbose: true }));
const CRON_OPTIONS = CRON_MAPPER.mapAll([
    "0 0 * * *",
    "0 0 * * 1-5",
    "0 0 * * 0",
    "0 0 1 * *",
    "0 6 * * *",
    "0 7 * * 1-5",
    "0 8-18 * * 1-5",
    "30 17 * * 1-5"
]);
export const validateExpression = (value) => {
    const splits = value.trim().split(" ");
    if (splits.length > 5) {
        throw Error(`Expression has ${splits.length} parts. Only 5 parts are supported.`);
    }
    const humanReadable = cronstrue.toString(value);
    const parsed = CronExpressionParser.parse(value);
    if (parsed.fields.minute.values.some((m) => m % 15 != 0)) {
        throw Error(`Expression minutes must be intervals of 15.`);
    }
    return humanReadable;
};
const CronExpressionInput = ({ value, onChange, isDisabled }) => {
    return (React.createElement(Creatable, { value: CRON_MAPPER.map(value), options: CRON_OPTIONS, onChange: selectOnChangeWrapperIfPresent(onChange), onCreateOption: (value) => {
            try {
                validateExpression(value);
            }
            catch {
                return;
            }
            onChange(value);
        }, menuPlacement: "top", formatCreateLabel: (value) => {
            try {
                const label = validateExpression(value);
                return `Create: ${label}`;
            }
            catch (err) {
                return (String(err).replace("At least 5 parts are required", "5 parts are required") +
                    " Please enter a valid Cron expression.");
            }
        }, placeholder: "Input a valid Cron expression", isDisabled: isDisabled }));
};
export default CronExpressionInput;
